import React, { useState } from "react";
import {
  Avatar,
  Box,
  Divider,
  Grid,
  Stack,
  Typography,
  Grow,
  useMediaQuery,
  IconButton,
  Zoom,
  MenuItem,
} from "@mui/material";
import { HiOutlineClock } from "react-icons/hi";
import { AiOutlineHeart } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { useTheme } from "@emotion/react";
import CountDownBoard from "../CountDownBoard/CountDownBoard";
import { add } from "date-fns";
import AddToCollectionModal from "../SellerDetailsOwnedModals/AddToCollectionModal";
import DeleteFromCollection from "../SellerDetailsOwnedModals/DeleteFromCollection";
import RemoveFromCollection from "../SellerDetailsOwnedModals/RemoveFromCollection";

// Styles
import styles from "./SellerDetailsCard.module.css";
import { GradientButtonPrimary } from "../../Utils/GradientButtons/GradientButtons";
import { FaThumbsUp } from "react-icons/fa";
import { KeyboardArrowDown } from "@mui/icons-material";
import { StyledMenu } from "../StyledMenu/StyledMenu";
import { useLocation, useNavigate } from "react-router-dom";

// This should come from the backend API
const futureDate = add(new Date(), {
  days: 7,
  hours: 12,
  minutes: 21,
});

const SellerDetailsCard = ({ sdc, darkMode }) => {
  const { t } = useTranslation();
  const {
    id,
    artworkImage,
    artworkTitle,
    artworkPrice,
    creator,
    creatorImage,
    owner,
    ownerImage,
    uploaded,
    likes,
    tag,
  } = sdc;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const location = useLocation();
  let navigate = useNavigate();

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // Add to collection modal
  const [openAddToCollectionModal, setOpenAddToCollectionModal] =
    useState(false);

  // Delete from collection modal
  const [openDeleteFromCollectionModal, setOpenDeleteFromCollectionModal] =
    useState(false);

  // Remove from collection modal
  const [openRemoveFromCollectionModal, setOpenRemoveFromCollectionModal] =
    useState(false);

  const parsedId = parseInt(id) * 100;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    //
    <Grow
      in={true}
      style={{ transformOrigin: "0 0 0" }}
      {...(true ? { timeout: 1000 + parsedId } : {})}
    >
      <Grid
        className={styles.sellerCard}
        item
        xs={1}
        sm={6}
        md={4}
        sx={{ zIndex: 600 }}
      >
        <div
          className={styles.sellerCard}
          onClick={() => navigate(`/explore/${1}`)}
        >
          <Box
            className={styles.sellerCardGradient}
            sx={{ padding: "1px", borderRadius: "20px" }}
          >
            <Box
              bgcolor={darkMode ? "#121212" : "#ffffff"}
              style={{
                display: "flex",
                flexDirection: "column",
                borderRadius: "20px",
                padding: "1rem",
                zIndex: "10",
                cursor: "pointer",
                position: "relative",
                boxShadow: `${!darkMode && "0px 4px 4px rgba(0, 0, 0, 0.25)"}`,
              }}
            >
              <Box style={{ position: "relative" }}>
                <img
                  style={{
                    width: "100%",
                    height: "250px",
                    borderRadius: "10px",
                  }}
                  src={artworkImage}
                  alt={artworkTitle}
                />
              </Box>
              <Box sx={{ mt: 3 }}>
                {tag === "ownedItems" ? (
                  <React.Fragment>
                    {location.pathname === "/user/dummy" && (
                      <Stack
                        mb={1}
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Typography
                          variant="subtitle1"
                          component="h2"
                          color="secondary.main"
                        >
                          {artworkTitle}
                        </Typography>
                        <IconButton onClick={handleOpenMenu}>
                          <KeyboardArrowDown />
                        </IconButton>
                        <StyledMenu
                          elevation={1}
                          TransitionComponent={Zoom}
                          anchorEl={anchorEl}
                          open={openMenu}
                          onClose={handleCloseMenu}
                          PaperProps={{
                            style: {
                              borderRadius: "10px",
                              backgroundColor: `${
                                darkMode ? "#121212" : "#ffffff"
                              }`,
                              color: `${darkMode ? "#ffffff" : "#121212"}`,
                            },
                          }}
                          MenuListProps={{
                            "aria-labelledby": "basic-button",
                          }}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "left",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "left",
                          }}
                        >
                          <MenuItem
                            onClick={() => {
                              setOpenAddToCollectionModal(true);
                              handleCloseMenu();
                            }}
                          >
                            <Typography variant="subtitle1" fontWeight={400}>
                              {t("ADD_TO_COLLECTION")}
                            </Typography>
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              setOpenRemoveFromCollectionModal(true);
                              handleCloseMenu();
                            }}
                          >
                            <Typography variant="subtitle1" fontWeight={400}>
                              {t("BURN_THE_NFT")}
                            </Typography>
                          </MenuItem>
                          <MenuItem
                            onClick={() => {
                              setOpenDeleteFromCollectionModal(true);
                              handleCloseMenu();
                            }}
                          >
                            <Typography variant="subtitle1" fontWeight={400}>
                              {t("REMOVE_FROM_SALE")}
                            </Typography>
                          </MenuItem>
                        </StyledMenu>
                      </Stack>
                    )}
                  </React.Fragment>
                ) : (
                  <Typography
                    variant="subtitle1"
                    component="h2"
                    color="secondary.main"
                    mb={1}
                  >
                    {artworkTitle}
                  </Typography>
                )}
                <Typography variant="subtitle2" component="p" color="gray">
                  {t("PRICE")}
                </Typography>
                <Typography
                  variant="subtitle1"
                  component="p"
                  color="secondary.main"
                  mb={2}
                >
                  {artworkPrice}
                </Typography>
                {tag === "auctionItems" ? (
                  <Box>
                    {!isMobile ? (
                      <Box>
                        <CountDownBoard
                          darkMode={darkMode}
                          futureDate={futureDate}
                          isCard={true}
                        />
                      </Box>
                    ) : (
                      <Box
                        sx={{ position: "absolute", top: "45%", left: "26%" }}
                      >
                        <CountDownBoard
                          darkMode={darkMode}
                          futureDate={futureDate}
                        />
                      </Box>
                    )}
                  </Box>
                ) : null}
                <Divider
                  style={{ backgroundColor: "#8E8E8E", margin: "10px 0" }}
                />
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                    <Box>
                      <Avatar
                        sx={{ border: "2px solid #ffffff" }}
                        src={creatorImage}
                        alt={creator}
                      />
                    </Box>
                    <Stack direction="column" alignItems="center">
                      <Typography variant="caption" gutterBottom color="gray">
                        {t("CREATOR")}
                      </Typography>
                      <Typography
                        variant="caption"
                        gutterBottom
                        color="secondary.main"
                      >
                        {creator}
                      </Typography>
                    </Stack>
                  </Box>
                  <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                    <Box>
                      <Avatar
                        sx={{ border: "2px solid #ffffff" }}
                        src={ownerImage}
                        alt={owner}
                      />
                    </Box>
                    <Stack direction="column" alignItems="center">
                      <Typography variant="caption" gutterBottom color="gray">
                        {t("OWNER")}
                      </Typography>
                      <Typography
                        variant="caption"
                        gutterBottom
                        color="secondary.main"
                      >
                        {owner}
                      </Typography>
                    </Stack>
                  </Box>
                </Box>
                {tag === "auctionItems" ? null : (
                  <Box>
                    <Divider
                      style={{ backgroundColor: "#8E8E8E", margin: "10px 0" }}
                    />
                    <Box
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Stack direction="row" gap={2} alignItems="center">
                        <HiOutlineClock
                          style={{
                            color: `${darkMode ? "#ffffff" : "#121212"}`,
                          }}
                        />
                        <Typography
                          variant="caption"
                          component="span"
                          color="gray"
                        >
                          {uploaded}
                        </Typography>
                      </Stack>
                      <Stack direction="row" gap={2} alignItems="center">
                        <AiOutlineHeart
                          style={{
                            color: `${darkMode ? "#ffffff" : "#121212"}`,
                          }}
                        />
                        <Typography
                          variant="caption"
                          component="span"
                          color="gray"
                        >
                          {likes}
                        </Typography>
                      </Stack>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </div>
        {tag === "auctionItems" && (
          <div className={styles.auctionCardButton}>
            <Box className={styles.auctionCardButtonBox}>
              <GradientButtonPrimary className={styles.gradientButton}>
                <Typography component="span" color="#ffffff" mt={0.5}>
                  <FaThumbsUp />
                </Typography>
                {!isMobile ? (
                  <Typography variant="body1" component="span">
                    {t("PLACE_YOUR_BID")}
                  </Typography>
                ) : (
                  <Typography variant="body2" component="span" fontSize="14px">
                    {t("PLACE_YOUR_BID")}
                  </Typography>
                )}
              </GradientButtonPrimary>
            </Box>
          </div>
        )}
        <AddToCollectionModal
          open={openAddToCollectionModal}
          handleClose={() => setOpenAddToCollectionModal(false)}
          darkMode={darkMode}
        />
        <DeleteFromCollection
          open={openDeleteFromCollectionModal}
          handleClose={() => setOpenDeleteFromCollectionModal(false)}
          darkMode={darkMode}
        />
        <RemoveFromCollection
          open={openRemoveFromCollectionModal}
          handleClose={() => setOpenRemoveFromCollectionModal(false)}
          darkMode={darkMode}
        />
      </Grid>
    </Grow>
  );
};

export default SellerDetailsCard;
